import { types } from "mobx-state-tree"

const UltimateSplitTime = types.model('UltimateSplitTime', {
    id: types.identifierNumber,
    key: types.string,
    name: types.string,
})

export default UltimateSplitTime
